import React, { useState } from "react";
import { languageJson } from "src/StringVariable";
import { motion, AnimatePresence } from "framer-motion";

const languageOptions = [
  { code: "en", label: languageJson.english_txt },
  { code: "es", label: languageJson.spanish_txt },
  { code: "pa", label: languageJson.punjabi_txt },
];

const dropdownVariants = {
  open: {
    opacity: 1,
    y: 0,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.07,
    },
  },
  closed: {
    opacity: 0,
    y: -10,
    transition: { when: "afterChildren", duration: 0.2 },
  },
};

const itemVariants = {
  open: { opacity: 1, y: 0 },
  closed: { opacity: 0, y: 10 },
};

const HomeLanguageChange = ({ onchange, value, name }) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedLabel =
    languageOptions.find((lang) => lang.code === value)?.label ||
    "Select Language";

  const handleSelect = (langCode) => {
    onchange({ target: { name, value: langCode } });
    setIsOpen(false);
  };

  return (
    <>
      {/* Native select for < 992px */}
      {/* <div onClick={(e) => e.stopPropagation()}>
        <select
          className="languageSelectDiv show-mobile"
          onChange={onchange}
          autoComplete="off"
          value={value}
          name={name}
        >
          <option value="en">{languageJson.english_txt}</option>
          <option value="es">{languageJson.spanish_txt}</option>
          <option value="pa">{languageJson.punjabi_txt}</option>
        </select>
      </div> */}

      {/* Custom floating dropdown for >= 992px */}
      <div className="floating-dropdown" onClick={(e) => e.stopPropagation()}>
        <div
          className="dropdown-header"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <span style={{ color: "white" }}>{selectedLabel}</span>
          <span className={`arrow ${isOpen ? "open" : ""}`}>▼</span>
        </div>

        <AnimatePresence>
          {isOpen && (
            <motion.ul
              className="dropdown-list"
              initial="closed"
              animate="open"
              exit="closed"
              variants={dropdownVariants}
            >
              {languageOptions.map((lang) => (
                <motion.li
                  key={lang.code}
                  className="dropdown-item"
                  variants={itemVariants}
                  onClick={() => handleSelect(lang.code)}
                >
                  {lang.label}
                </motion.li>
              ))}
            </motion.ul>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};

export default HomeLanguageChange;
